"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyPageSetInstanceOptions = exports.PropertyPageModel = void 0;
const tslib_1 = require("tslib");
require("babel-polyfill");
const Instance_1 = require("./Instance");
const Base_1 = require("./Base");
class PropertyPageModel {
    constructor() {
        this.mode = Base_1.PropertyPageMode.Edit;
        this.showVersions = false;
        this.notNullFields = [];
        this.notNullFieldsErrorFormat = "";
        this.options = {}; // Das würde eigentlich auch noch auf eine TypeScript-Klasse umgebaut gehören
        this.controls = {}; // Das würde eigentlich auch noch auf eine TypeScript-Klasse umgebaut gehören
        this.triggerFields = [];
    }
    static fromJSON(json) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let returnPPModel = new PropertyPageModel();
            let instanceJSON = json["instance"];
            if (instanceJSON) {
                returnPPModel.instance = yield Instance_1.Instance.fromJSON(instanceJSON);
            }
            returnPPModel.mode = json["mode"];
            returnPPModel.showVersions = json["showVersions"];
            returnPPModel.notNullFields = json["notNullFields"];
            let notNullFieldsErrorFormat = json["notNullFieldsErrorFormat"];
            if (notNullFieldsErrorFormat)
                returnPPModel.notNullFieldsErrorFormat = json["notNullFieldsErrorFormat"];
            returnPPModel.options = json["options"];
            let controls = json["controls"];
            if (controls)
                returnPPModel.controls = controls;
            let triggerFields = json["triggerFields"];
            if (triggerFields)
                returnPPModel.triggerFields = triggerFields;
            return returnPPModel;
        });
    }
}
exports.PropertyPageModel = PropertyPageModel;
class PropertyPageSetInstanceOptions {
    constructor() {
        this.showVersions = undefined;
        this.propertyPage = undefined;
        this.parentId = undefined;
        this.parentRelId = undefined;
        this.mode = Base_1.PropertyPageMode.Edit;
        this.id = undefined;
        this.tagName = undefined;
        this.overrideInitialMode = false;
        this.verCur = undefined;
        this.clear = undefined; //clear is Hotfix for fush refresh
        this.done = undefined;
        this.cleanUp = undefined;
    }
    static fromJSON(json) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let returnPPOModel = new PropertyPageSetInstanceOptions();
            returnPPOModel.showVersions = json["showVersions"];
            if (json["propertyPage"]) {
                returnPPOModel.propertyPage = yield PropertyPageModel.fromJSON(json["propertyPage"]);
            }
            returnPPOModel.parentId = json["parentId"];
            returnPPOModel.parentRelId = json["parentRelId"];
            returnPPOModel.mode = json["mode"];
            returnPPOModel.id = json["id"];
            returnPPOModel.tagName = json["tagName"];
            returnPPOModel.overrideInitialMode = json["overrideInitialMode"];
            returnPPOModel.done = json["done"];
            returnPPOModel.cleanUp = json["cleanUp"];
            returnPPOModel.clear = json["clear"];
            return returnPPOModel;
        });
    }
}
exports.PropertyPageSetInstanceOptions = PropertyPageSetInstanceOptions;
